export const SET_ROOM_ID = 'SET_ROOM_ID';
export const SET_NAME = 'SET_NAME';
export const SET_PLAYERS = 'SET_PLAYERS';
export const SAVE_GAME_SETTINGS = 'SAVE_GAME_SETTINGS';
export const SET_CURRENT_PLAYER = 'SET_CURRENT_PLAYER';
export const SET_OPTIONS = 'SET_OPTIONS';
export const SET_DRAWING_MODE = 'SET_DRAWING_MODE';
export const SET_TIME_OVER = 'SET_TIME_OVER';
export const SET_CURRENT_ROUND = 'SET_CURRENT_ROUND';
export const RESET = 'RESET';
export const SET_SCORE = 'SET_SCORE';
export const SET_CURRENT_WORD = 'SET_CURRENT_WORD';
export const SET_SHOW_OPTIONS_SCREEN = 'SET_SHOW_OPTIONS_SCREEN';
export const SET_MESSAGES = 'SET_MESSAGES';
